import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import ProductTypeForm from "./ProductTypeForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { productTypeValidationForm } from "../../utils/validationSchemas";

const CreateProductType = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(productTypeValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <ProductTypeForm
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
    </FormLayout>
  );
};

export default CreateProductType;
